module.exports = __webpack_public_path__ + "static/media/record.b9840746.svg";